import { render, staticRenderFns } from "./ehc-form.vue?vue&type=template&id=2c31cce2"
import script from "./ehc-form.vue?vue&type=script&lang=js"
export * from "./ehc-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports